import * as fromDatatype from "../datatype-library/index";

export class bl_mrp_pick_pack_queue_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  qty_balance: fromDatatype.NumericDatatypeInterface;
  awaiting_approval: fromDatatype.NumericDatatypeInterface;
  base_qty: fromDatatype.NumericDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  running_number: fromDatatype.VarcharDatatypeInterface;
  machine_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  est_packing_date: fromDatatype.TimestampTzDatatypeInterface;
  acceptance_criterion: fromDatatype.VarcharDatatypeInterface;
  acceptance_deviation: fromDatatype.NumericDatatypeInterface;
}

export class bl_mrp_pick_pack_queue_RowClass implements bl_mrp_pick_pack_queue_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  qty_balance: fromDatatype.NumericDatatypeInterface;
  awaiting_approval: fromDatatype.NumericDatatypeInterface;
  base_qty: fromDatatype.NumericDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  running_number: fromDatatype.VarcharDatatypeInterface;
  machine_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  est_packing_date: fromDatatype.TimestampTzDatatypeInterface;
  acceptance_criterion: fromDatatype.VarcharDatatypeInterface;
  acceptance_deviation: fromDatatype.NumericDatatypeInterface;
}